import {
  doc,
  onSnapshot,
  deleteDoc,
  getDocs,
  updateDoc,
  query,
  where,
  getDoc,
  setDoc,
} from "firebase/firestore";
import { getCollectionRef, getDocumentRef } from "../utils";
import { getCategory } from "../categories/categoriesApi";

async function getProduct(id) {
  //ref to the product to get
  const productRef = getDocumentRef("products", id);

  try {
    const product = await getDoc(productRef);
    const productData = { ...product.data(), id: product.id };
    return { data: productData };
  } catch (err) {
    console.log(err);
    return { error: "And error occured while getting the product" };
  }
}

async function getAllProducts(globalStateAddAllProducts = (data) => {}) {
  //ref products collection
  const productsRef = getCollectionRef("products");
  const products = [];

  try {
    onSnapshot(productsRef, async (productSnapshot) => {
      const getCategoryOfProduct = async (
        idCategory,
        productsData,
        products
      ) => {
        //get the category
        const { category, error } = await getCategory(idCategory);

        //add to the products
        products.push({
          ...productsData,
          categoryMembership: category.name.toLowerCase(),
        });
      };

      const products = [];

      for (let product of productSnapshot.docs) {
        const productData = { ...product.data(), id: product.id };

        //ref to the product category
        const categoryRef = productData.categoryMembership;

        await getCategoryOfProduct(categoryRef.id, productData, products);
      }

      globalStateAddAllProducts(products);
    });
  } catch (err) {
    console.log(err);
    return { error: "firebase error while getting all products" };
  }
}

const createProduct = async (data) => {
  //ref gatégories collection
  const productsRef = getCollectionRef("products");

  //ref to the product to create
  const newProductRef = doc(productsRef);

  try {
    //create product with the gicen data and add the id
    await setDoc(newProductRef, { ...data, id: newProductRef.id });
    return { data: true };
  } catch (err) {
    console.log(err);
    return {
      error: "And error occured on firebase while creating the product",
    };
  }
};

/**
 * delete the product on firebase database
 * @param {string} id
 * @returns
 */
const deleteProduct = async (id) => {
  console.log(id);
  //doc ref
  const docRef = getDocumentRef("products", id);

  try {
    //delete product
    await deleteDoc(docRef);
    return { data: true };
  } catch (err) {
    console.log(err);
    return {
      error: "And error occured while deleting the product on firebase",
    };
  }
};

/**
 * update the product on firebase database
 * @param {string} idProduct
 * @param {Object} data
 * @returns
 */
const updateProduct = async (idProduct, data) => {
  //ref to the product to update
  const productRef = getDocumentRef("products", idProduct);

  try {
    //update the product
    await updateDoc(productRef, { ...data });

    return { data: true };
  } catch (err) {
    console.log(err);
    return { error: "And error occured while updating the product" };
  }
};

/**
 * Get all the saved products of the user
 * @param {Array} prductsRefList
 */
const getUserSavedProducts = async (prductsRefList) => {
  if (!prductsRefList.length) return { data: [] };

  //get the list of id of the saved products
  const productsIdList = prductsRefList.map((productRef) =>
    productRef.id.trim()
  );

  //ref to the products collection
  const productsRef = getCollectionRef("products");

  //query to select the user products
  const q = query(productsRef, where("id", "in", productsIdList));

  try {
    const querySnapshot = await getDocs(q);

    const userSavedProducts = [];

    querySnapshot.forEach((doc) => {
      const product = { ...doc.data(), id: doc.id };
      userSavedProducts.push(product);
    });

    return { data: userSavedProducts };
  } catch (err) {
    console.log(err);
    return { error: "And error occured while getting the user saved products" };
  }
};

export {
  getAllProducts,
  createProduct,
  updateProduct,
  deleteProduct,
  getUserSavedProducts,
  getProduct,
};
